import { DatePickerInput } from "@erelego/design-system/components/atoms/DatePickerInput";
import {
  DateInitialValueType,
  IDatepickerFieldConfigurationClient,
  IDatepickerFieldConfigurationServer,
  IInitialValueRender,
} from "./interface";
import { DatePicker } from "@assets/images";
import React from "react";
import StandardInput from "@erelego/design-system/components/atoms/StandardInput";

export const transformDateInputFieldConfigClientToServer = (
  fieldConfigClient: IDatepickerFieldConfigurationClient
): IDatepickerFieldConfigurationServer => {
  const {
    initialValue,
    writeJavascript,
    dateFormat,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    isPartOfTimeSlot,
    isCurrentDateSelected,
    dateInitialValueType,
    isPastDateDisabled,
    fromFieldId,
    toFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
  } = fieldConfigClient;
  const fieldConfigServer = {
    initialValue: initialValue,
    writeJavascript: writeJavascript,
    dateFormat: dateFormat,
    dateRangeEnabled: dateRangeEnabled,
    isWeekendDisabled: isWeekendDisabled,
    specificDateSelectionEnabled: specificDateSelectionEnabled,
    specificDateRangeEnabled: specificDateRangeEnabled,
    jsonApiEnabled: jsonApiEnabled,
    preDisableDateCount: preDisableDateCount,
    postDisableDateCount: postDisableDateCount,
    specificDates: specificDates,
    specificDateRange: specificDateRange,
    dateJsonApiUrl: dateJsonApiUrl,
    isPartOfTimeSlot: isPartOfTimeSlot,
    isCurrentDateSelected: isCurrentDateSelected,
    dateInitialValueType: dateInitialValueType,
    isPastDateDisabled: isPastDateDisabled,
    fromFieldId: fromFieldId ?? "",
    toFieldId: toFieldId ?? "",
    isMonthDisplayRequired: isMonthDisplayRequired,
    monthDisplayFieldId: monthDisplayFieldId,
  };
  return fieldConfigServer;
};

export const transformDateInputConfigServerToClient = (
  fieldConfigServer: IDatepickerFieldConfigurationServer
): IDatepickerFieldConfigurationClient => {
  const {
    initialValue,
    writeJavascript,
    dateFormat,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    isPartOfTimeSlot,
    isCurrentDateSelected,
    dateInitialValueType,
    isPastDateDisabled,
    fromFieldId,
    toFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
  } = fieldConfigServer;
  const fieldConfigClient = {
    initialValue: initialValue,
    dateFormat: dateFormat,
    writeJavascript: writeJavascript,
    dateRangeEnabled: dateRangeEnabled,
    isWeekendDisabled: isWeekendDisabled,
    specificDateSelectionEnabled: specificDateSelectionEnabled,
    specificDateRangeEnabled: specificDateRangeEnabled,
    jsonApiEnabled: jsonApiEnabled,
    preDisableDateCount: preDisableDateCount,
    postDisableDateCount: postDisableDateCount,
    specificDates: specificDates,
    specificDateRange: specificDateRange,
    dateJsonApiUrl: dateJsonApiUrl,
    isPartOfTimeSlot: isPartOfTimeSlot,
    isCurrentDateSelected: isCurrentDateSelected,
    dateInitialValueType: dateInitialValueType,
    isPastDateDisabled: isPastDateDisabled,
    fromFieldId: fromFieldId ?? "",
    toFieldId: toFieldId ?? "",
    isMonthDisplayRequired: isMonthDisplayRequired,
    monthDisplayFieldId: monthDisplayFieldId,
  };
  return fieldConfigClient;
};

export const getInitialValueType = (
  valueType: DateInitialValueType
): string => {
  switch (valueType) {
    case DateInitialValueType?.currentDate:
      return "Current Date";
    case DateInitialValueType?.setInitialValue:
      return "Set Initial Value";
    case DateInitialValueType?.initialValueWithAccessKey:
      return "Access key";
  }
};
export const getInitialValueRenderComponent = (
  data: IInitialValueRender
): React.ReactNode => {
  const { type, onDateChange, value, onAccessKeyChange } = data;
  let initialValue: React.ReactNode = <></>;
  switch (type) {
    case DateInitialValueType?.setInitialValue:
      initialValue = (
        <DatePickerInput
          className="date-picker-input"
          name="Date"
          DateMode="date"
          onDateChange={onDateChange}
          value={value}
          rightIcon={DatePicker}
          isFloatingLabel
          placeholder="Initial value"
        />
      );
      break;
    case DateInitialValueType?.initialValueWithAccessKey:
      initialValue = (
        <StandardInput
          value={value}
          onTextChange={onAccessKeyChange}
          placeholder="Enter Access Key"
          isFloatingLabel
        />
      );
      break;
  }
  return initialValue;
};

export const initialValueUpdate = (dateString: string) => {
  if (!dateString || typeof dateString !== "string" || dateString.trim() === "") {
    return "";
  }
  const parts = dateString.split("/");
  if (parts.length !== 3) {
    return "";
  }
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return "";
  }
  const date = new Date(year, month, day, 0, 0, 0, 0);
  if (isNaN(date.getTime())) {
    return "";
  }
  
  return date;
};

export const getMonthFromDate = (selectedDate: string) => {
  const date = new Date(selectedDate);

  if (isNaN(date.getTime())) return "";

  return date.toLocaleString("default", { month: "long" });
};